var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"l-content full relative page-bg"},[(_vm.statData)?_c('head-panel',{attrs:{"config":_vm.config,"condition":_vm.condition},on:{"change":_vm.change}}):_vm._e(),(_vm.statData)?_c('chart-container',{attrs:{"stat-data":_vm.statData,"config":_vm.config}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }